import React from 'react'
import PropTypes from 'prop-types';
import getObjectValue from 'libs/getObjectValue';
import TextInput from "components/TextInput";
import Tr from 'translations/Translations'
import SortableHandle from "components/complex/sortable/SortableHandle";
import GridBlock from "components/GridBlock";
import Select, {createSelectItem} from "components/Select";
import Button from "components/Button";
import {FormHelperText, makeStyles} from "@material-ui/core";
import RadioGroupYesNo from "components/RadioGroupYesNo";
import BoldTypography from "components/BoldTypography";
import {PurchasingGroupTemplateFieldType, PurchasingGroupTemplateFieldTypeLabel} from "../constants/PurchasingGroupTemplateFieldType";
import WorkableIconDeleteButton from "components/button/WorkableIconDeleteButton";


const useStyle = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(2),
        "&>*:nth-child(1)": {
            width: 60,
            alignSelf: "center"
        },
        "&>*:nth-child(2)": {
            width: 25,
            alignSelf: "center"
        },
        "&>*:nth-child(3)": {
            flexGrow: 1,
            paddingRight: theme.spacing(3)
        },
        "&>*:nth-child(4)": {
            width: 120,
            paddingRight: theme.spacing(3)
        },
        "&>*:nth-child(5)": {
            paddingRight: theme.spacing(2),
            textAlign: 'center'
        },
        "&>*:nth-child(6)": {
            alignSelf: "center"
        }
    },
    yesNo: {
        "&>*.MuiFormGroup-root": {
            flexDirection: "row"
        }
    },
    ol: {
        paddingInlineStart: theme.spacing(2),
        marginLeft: theme.spacing(),
        marginRight: theme.spacing(),
    },
    error: {
        marginTop: theme.spacing(),
        marginBottom: theme.spacing(2),
    }
}))

function PurchasingGroupTemplateField(
    {
        index,
        id,
        setAggregatedFieldId,
        formikProps,
        hasEdit
    }) {
    const fieldId = `${id}.${index}`
    const createId = key => `${fieldId}.${key}`
    const classes = useStyle();
    const field = getObjectValue(fieldId, formikProps.values, {});
    const aggregatedFieldErrorValue = getObjectValue(createId("aggregatedFields"), formikProps.errors, '')

    const getTooltip = () => {
        if (field && field.aggregatedFields && field.aggregatedFields.length > 0) {
            const fields = getObjectValue(id, formikProps.values, []);
            return <ul className={classes.ol}>{fields.map((x, i) => ({
                ...x,
                order: i + 1
            })).filter(x => field.aggregatedFields.includes(x.uniqueId)).map((x, i) => <li key={i}>{x.order + ". " + x.name}</li>)}</ul>
        }
    }

    const onTypeChange = (e) => {
        if (e.target.value !== PurchasingGroupTemplateFieldType.NUMBER) {
            const allFields = getObjectValue(id, formikProps.values, []);
            let updated = false;
            const newAllFields = allFields.map(x => x.type === PurchasingGroupTemplateFieldType.AGGREGATE ? {
                ...x, aggregatedFields:
                    (() => {
                        if (x.aggregatedFields.indexOf(field.uniqueId) > -1) {
                            updated = true;
                            return x.aggregatedFields.filter(y => y !== field.uniqueId);
                        } else {
                            return x.aggregatedFields;
                        }
                    })()
            } : x)
            if (updated) {
                formikProps.setFieldValue(id, newAllFields.map(x => x.uniqueId === field.uniqueId ? {...x, type: e.target.value} : x), true)
            }
        }
    }

    const doDelete = (e) => {
        const allFields = getObjectValue(id, formikProps.values, []);
        const newAllFields = allFields.filter(x => x.uniqueId !== field.uniqueId).map(x => x.type === PurchasingGroupTemplateFieldType.AGGREGATE ? {
            ...x, aggregatedFields:
                (() => {
                    if (x.aggregatedFields.indexOf(field.uniqueId) > -1) {
                        return x.aggregatedFields.filter(y => y !== field.uniqueId);
                    } else {
                        return x.aggregatedFields;
                    }
                })()
        } : x)
        formikProps.setFieldValue(id, newAllFields, true)
    }

    return (
        <GridBlock className={classes.root}>

            <SortableHandle/>
            <BoldTypography className={classes.index}>{index + 1}.</BoldTypography>
            <TextInput
                formikProps={formikProps}
                id={createId('name')}
                label={Tr('name')}
                required
                disabled={!hasEdit}
                multiline
            />

            <Select
                formikProps={formikProps}
                id={createId('type')}
                label={Tr("type")}
                items={Object.keys(PurchasingGroupTemplateFieldType).map(x => createSelectItem(x, PurchasingGroupTemplateFieldTypeLabel(x)))}
                onChange={onTypeChange}
                disabled={!hasEdit}
            />

            {
                field.type === "AGGREGATE" ?
                    <>
                        <Button disabled={!hasEdit} tooltip={getTooltip()} onClick={() => setAggregatedFieldId(createId('aggregatedFields'))}>
                            {Tr("selected_fields") + ": " + getObjectValue(createId('aggregatedFields'), formikProps.values, []).length}
                        </Button>
                        <FormHelperText error className={classes.error}>{aggregatedFieldErrorValue}</FormHelperText>
                    </>
                    : <RadioGroupYesNo
                        className={classes.yesNo}
                        formikProps={formikProps}
                        id={createId('required')}
                        label={Tr("required_field")}
                        items={[{value: true, label: Tr("yes")}, {value: false, label: Tr("no")}]}
                        disabled={!hasEdit}
                    />
            }

            <WorkableIconDeleteButton onClick={doDelete} disabled={!hasEdit} />

        </GridBlock>
    )
}

PurchasingGroupTemplateField.propTypes = {
    classes: PropTypes.any,
}

export default PurchasingGroupTemplateField;